/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Share_TitleInputs */

const en_us2_wrapped_share_title = /** @type {(inputs: Wrapped_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My retrospective · My Pocket Gym`)
};

const pt_br2_wrapped_share_title = /** @type {(inputs: Wrapped_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minha retrospectiva · My Pocket Gym`)
};

const es_419_wrapped_share_title = /** @type {(inputs: Wrapped_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi resumen · My Pocket Gym`)
};

const pt_pt2_wrapped_share_title = /** @type {(inputs: Wrapped_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A minha retrospetiva · My Pocket Gym`)
};

const fr_fr2_wrapped_share_title = /** @type {(inputs: Wrapped_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon bilan · My Pocket Gym`)
};

const de_de2_wrapped_share_title = /** @type {(inputs: Wrapped_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mein Rückblick · My Pocket Gym`)
};

const it_it2_wrapped_share_title = /** @type {(inputs: Wrapped_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il mio riepilogo · My Pocket Gym`)
};

/**
* | output |
* | --- |
* | "My retrospective · My Pocket Gym" |
*
* @param {Wrapped_Share_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_share_title = /** @type {((inputs?: Wrapped_Share_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Share_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_share_title(inputs)
	if (locale === "es-419") return es_419_wrapped_share_title(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_share_title(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_share_title(inputs)
	if (locale === "de-DE") return de_de2_wrapped_share_title(inputs)
	if (locale === "it-IT") return it_it2_wrapped_share_title(inputs)
	return en_us2_wrapped_share_title(inputs)
});
export { wrapped_share_title as "wrapped.share_title" }